export const activityConfig = {
    title: '日常生活活动能力评估表',
    explain:
        '能力完好：总分100分；轻度受损：总分65-95分；中度受损：总分45-60分；重度受损：总分<=40分',
    result: totleScore => {
        let result = '';
        switch (true) {
            case totleScore === 100:
                result = '能力完好';
                break;
            case totleScore <= 95 && totleScore >= 65:
                result = '轻度受损';
                break;
            case totleScore <= 65 && totleScore >= 45:
                result = '中度受损';
                break;
            default:
                result = '重度受损';
                break;
        }
        return result;
    },
    qus: [
        {
            title: '进食：指用餐具将食物由容器送到口中、咀嚼、吞咽等过程',
            options: [
                { label: '可独立进食（在合理的时间内独立进食准备好的食物）', score: 10 },
                { label: '需部分帮助（进食过程中需要一定的帮助，如协助把持餐具）', score: 5 },
                { label: '需极大帮助或完全依赖他人，或有留置营养管', score: 0 },
            ],
        },
        {
            title: '洗澡：',
            options: [
                { label: '准备好洗澡水后，可自己独立完成洗澡过程', score: 5 },
                { label: '在洗澡过程中需他人帮助', score: 0 },
            ],
        },
        {
            title: '修饰：',
            options: [
                { label: '可自己独立完成', score: 5 },
                { label: '需他人帮助', score: 0 },
            ],
        },
        {
            title: '穿衣：',
            options: [
                { label: '可独立完成', score: 10 },
                {
                    label: '需部分帮助（能自己穿脱，但需他人帮助整理衣物、系扣/鞋带、拉拉链）',
                    score: 5,
                },
                { label: '需极大帮助或完全依赖他人', score: 0 },
            ],
        },
        {
            title: '大便控制：',
            options: [
                { label: '可控制大便', score: 10 },
                { label: '偶尔失控（每周<1次），或需要他人提示', score: 5 },
                { label: '完全失控', score: 0 },
            ],
        },
        {
            title: '小便控制：',
            options: [
                { label: '可控制小便', score: 10 },
                { label: '偶尔失控（每天<1次，但每周>1次），或需要他人提示', score: 5 },
                { label: '完全失控，或留置导尿管', score: 0 },
            ],
        },
        {
            title: '如厕：包括去厕所、解开衣裤、擦净、整理衣裤、冲水：',
            options: [
                { label: '可独立完成', score: 10 },
                { label: '需部分帮助（需他人搀扶去厕所、需他人帮忙冲水或整理衣裤等）', score: 5 },
                { label: '需极大帮助或完全依赖他人', score: 0 },
            ],
        },
        {
            title: '床椅转移：',
            options: [
                { label: '可独立完成', score: 15 },
                { label: '需部分帮助（需他人搀扶或使用拐杖）', score: 10 },
                { label: '需极大帮助（较大程度上依赖他人搀扶和帮助）', score: 5 },
                { label: '完全依赖他人', score: 0 },
            ],
        },
        {
            title: '平地行走：',
            options: [
                { label: '可独立在平地上行走45m', score: 15 },
                {
                    label: '需部分帮助（因肢体残疾、平衡能力差、过渡衰弱、视力等问题，在一定程度上需他人的搀扶或使用拐杖、助行器等辅助工具）',
                    score: 10,
                },
                {
                    label: '需极大帮助（因肢体残疾、平衡能力差、过渡衰弱、视力等问题，在较大程度上需他人的搀扶，或坐在轮椅上自行移动）',
                    score: 5,
                },
                { label: '完全依赖他人', score: 0 },
            ],
        },
        {
            title: '上下楼梯：',
            options: [
                { label: '可独立上下楼梯（连续上下10-15个台阶）', score: 10 },
                { label: '需部分帮助（需扶着楼梯、他人搀扶，或使用拐杖等）', score: 5 },
                { label: '需极大帮助或完全依赖他人', score: 0 },
            ],
        },
    ],
};
